export const copyText = (text) =>
  window.navigator.clipboard
    .writeText(text)
    .then(() => alert("Copied to clipboard"));
